<template>
    <div class="admin-table">
        <v-simple-table style="width: 100%;" class="table report">
            <thead>
                <tr>
                    <th>
                        <v-btn v-if="editing" text color="bal-red" dark @click="handleResetClick">Reset</v-btn>
                    </th>
                    <th
                        v-for="action in allActions"
                        :id="action"
                        @click="toggleActions(action)"
                        :class="{ 'cursor-pointer': !disabled }"
                    >
                        {{ getActionName(action) }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <user-permission-table
                    v-for="permission in Object.keys(allPermissions)"
                    :key="permission"
                    :item="permission"
                    :allPermissions="allPermissions[permission]"
                    :allActions="allActions"
                    :userRole="userRole"
                    :disabled="disabled"
                />
            </tbody>
        </v-simple-table>
    </div>
</template>

<script>
import UserPermissionTable from "./user-permission-table.vue";
import { PermissionsConstants } from "@/permissions";
import { mapMutations, mapState } from "vuex";

export default {
    name: "user-permissions",
    components: {
        "user-permission-table": UserPermissionTable
    },
    props: ["disabled", "editing"],
    computed: {
        ...mapState("UserStore", ["activeUser", "allPermissions", "allActions"]),
        permissions: function() {
            return this.activeUser.permissions || {};
        }
    },
    data() {
        return {
            userRole: "customer",
            boolActions: false,
            p: PermissionsConstants
        };
    },
    methods: {
        ...mapMutations("UserStore", ["addPermission", "removeViewPermissions", "resetPermissions"]),

        getActionName(action) {
            if (action === "only-by-self") return this.t("Only by self");
            return this.t((action.charAt(0).toUpperCase() + action.slice(1)).replace("-", " "));
        },
        toggleActions(action) {
            if (this.disabled) {
                return;
            }

            Object.keys(this.permissions).forEach(p => {
                if (this.boolActions) {
                    if (!this.permissions[p].includes(action)) {
                        this.addPermission({ action: action, view: p });
                    }
                } else {
                    if (this.permissions[p].includes(action)) {
                        let index = this.permissions[p].indexOf(action);
                        this.removeViewPermissions({
                            view: p,
                            start: index,
                            end: 1
                        });
                    }
                }
            });
            this.boolActions = !this.boolActions;
        },
        handleResetClick() {
            this.resetPermissions();
        }
    }
};
</script>

<style scoped></style>
